export enum LegalDocumentType {
  MENTIONS_LEGALES = 'mentions-legales',
  POLITIQUE_CONFIDENTIALITE = 'politique-confidentialite',
  COOKIES = 'cookies',
  CGU = 'cgu',
}

export const LEGAL_DOCUMENT_TYPES = Object.values(LegalDocumentType)

// Locales publiables — alignées sur l'enum Locale de @/locales/index.
export const LEGAL_DOCUMENT_LOCALES = ['fr', 'en', 'it', 'fr-BE', 'nl-BE'] as const

export type LegalDocumentLocale = (typeof LEGAL_DOCUMENT_LOCALES)[number]

export type LegalDocument = {
  id: number
  type: LegalDocumentType
  locale: LegalDocumentLocale
  content: string
  version: number
  publishedAt: string
}

// Documents contractuels : seuls ceux-ci demandent une acceptation explicite. Les trois
// autres types sont informatifs (les cookies passent par le bandeau de consentement).
export const LEGAL_DOCUMENT_TYPES_REQUIRING_ACCEPTANCE: LegalDocumentType[] = [
  LegalDocumentType.CGU,
]

// Document que l'utilisateur doit accepter avant de continuer (GET legal_documents/pending).
// `referenceVersion` est la version de la locale de référence (fr), pas celle de la
// traduction affichée dans `content` : les numéros divergent entre locales, et c'est la
// version fr qui fait foi. C'est donc elle qu'il faut renvoyer à l'acceptation.
export type PendingLegalDocument = {
  id: string
  type: LegalDocumentType
  referenceVersion: number
  locale: LegalDocumentLocale
  content: string
}
